import React from 'react';
import PropTypes from 'prop-types';
import RCore from 'RCore';
import { styledUI } from '../../StyledUI';
import SMTeamLogo from './../SMTeamLogo';
import styled, { withTheme } from 'styled-components';

const Container = styled.div``;

const LIList = styled.div`
    position: relative;
    display: flex;
    line-height: 20px;
    align-items: center;
    z-index: 2;
    margin-bottom: 10px;
    color: ${props => props.theme.color};

    &:last-child {
        margin-bottom: 0;
    }

    & > * {
        z-index: 2;
    }

    &.pls_highlight {
        color: ${props => props.theme.content.accentColor};
    }
    .tl-title {
        font-size: 18px !important;
        font-weight: normal !important;
        text-transform: uppercase;
        flex-grow: 1;
    }

    .tl-player-country {
        display: flex;
        align-items: center;
        line-height: 14px;

        .tl-team {
            font-size: 18px;
            margin-left: 10px;
            color: ${props => props.theme.color};
        }
    }
    .list-player-name {
        font-size: 36px;
        line-height: 1.25em;
        flex-grow: 1;
        text-align: left;
        white-space: nowrap;
        position: relative;
        z-index: 3;
        padding-left: 10px;
        width: 50%;

        > div {
            overflow: hidden;
            text-overflow: ellipsis;
        }
    }
    .tl-score {
        text-align: right;
        font-size: 75px;
        line-height: 1em;
        transform: translateY(-4px);
        margin-left: 10px;
        font-weight: bold;
        white-space: nowrap;
        position: relative;
        z-index: 3;
    }
    .tl-unit {
        font-size: 22px;
    }

    .tl-rank-badge {
        position: absolute;
        top: 0;
        left: 0;
        z-index: 111;
        font-size: 16px;
        line-height: 1em;
        width: 33px;
        height: 33px;
        font-weight: bold;
        color: ${props => props.theme.content.accent2TextColor};
        background-color: ${props => props.theme.content.accent2Color};
        border-radius: 50%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
`;

const Header = () => {
    return <div />;
};

const PlayerLogo = withTheme(({ theme, player, seasonId, ...props }) => {
    const SMPlayerLogo = styledUI.getCustomComponentFromTheme(theme, 'playerLogo', props);
    const isPhoto = SMPlayerLogo.name === 'PlayerLogoPhoto' || SMPlayerLogo.name === 'PlayerRoundedPhoto';
    const isRoundedPhoto = SMPlayerLogo.name === 'PlayerRoundedPhoto';

    const playerLogoStyle = isPhoto
        ? {
              width: '90',
              style: {
                  width: '100%'
              },
              imageWrapStyle: {
                  width: '90px',
                  height: isRoundedPhoto ? '90px' : 'auto',
                  border: isRoundedPhoto ? '1px solid #fff' : 'none',
                  overflow: 'hidden',
                  display: 'block'
              }
          }
        : {
              width: '90',
              imageWrapStyle: {
                  paddingLeft: 0
              }
          };

    return (
        <div style={{ position: 'relative' }}>
            <SMPlayerLogo
                teamId={player.teamId}
                playerId={player.id}
                seasonId={seasonId}
                size="large"
                height="auto"
                isGK={player.GK}
                number={player.shirtNumber}
                {...playerLogoStyle}
            />
        </div>
    );
});

const Row = ({ player, seasonId, highlightFirstPlayer, highlightTeam, rank, ...props }) => {
    const name = RCore.getFirstLastName(player.name);

    return (
        <LIList
            key={player.id}
            className={highlightFirstPlayer || highlightTeam === player.teamId ? 'pls_highlight' : ''}
        >
            <div className="tl-rank-badge">#{rank + 1}</div>
            <PlayerLogo player={player} seasonId={seasonId} playerLogoDisplay={props.playerLogoDisplay} />
            <div className="list-player-name">
                <div>
                    {name.firstName} {name.lastName}
                </div>

                <div className="tl-player-country">
                    <SMTeamLogo teamId={player.teamId} seasonId="current" display="logo" width={30} height={30} />
                    <div className="tl-team">{player.teamShortName}</div>
                </div>
            </div>
            <div className="tl-score">{player.displayValue || player.value}</div>
        </LIList>
    );
};

Header.contextTypes = {
    info: PropTypes.object
};

Row.contextTypes = {
    info: PropTypes.object
};

export default { Header, Row, Container };



/** WEBPACK FOOTER **
 ** ../src/widgets/components/sm/views/lists/PlayersListStyle1.js
 **/